/**
 * Where to go after signing in. A signed-out visit to a deep link (a contract
 * from an email, say) sends the person to login with that address in the
 * `next` query parameter, and login takes them back there. Only an in-app
 * path is honoured, so a crafted link cannot bounce someone to another site.
 */
const PARAM = "next";

export const loginPathFor = (path: string): string =>
  path && path !== "/" && !path.startsWith("/login")
    ? `/login?${PARAM}=${encodeURIComponent(path)}`
    : "/login";

export const returnToFromSearch = (search: string): string => {
  const next = new URLSearchParams(search).get(PARAM) ?? "";
  return next.startsWith("/") && !next.startsWith("//") && !/^\/[\\]/.test(next) ? next : "/";
};
